export default __webpack_public_path__ + "static/Explorer-70d70b0d825da870be67552039095cae.png";